import { string, bool, object, lazy } from 'yup'
import { validateMessage } from '~/constants/validation-message'

export const registerValidationSchema = object({
  username: string()
    .required(' ')
    .matches(/^[a-zA-Z0-9]+$/, validateMessage.usernameNoSpecialChars)
    .test(
      'length-check',
      validateMessage.userName({ min: 6, max: 29 }),
      (value) => value?.length >= 6 && value?.length <= 29,
    ),
  password: string()
    .required(' ')
    .matches(/^\S*$/, validateMessage.noWhitespacePassword)
    .min(6, ({ min }) => validateMessage.minPassword(min)),
  confirmPassword: string()
    .required(' ')
    .min(6, ({ min }) => validateMessage.minLength(min))
    .test(
      'password-match',
      validateMessage.passwordNotMatch,
      (value, { parent }) => {
        return !!value && value === parent.password
      },
    ),
  phoneNumber: string()
    .required(' ')
    .matches(/^0/, validateMessage.phoneNumberMustStartWithZero)
    .min(10, validateMessage.minLengthNumber(10)),
  termAcception: bool().oneOf([true], ' '),
  captchaToken: lazy(() => {
    const { CAPTCHA_ENABLED } = useRuntimeConfig().public

    if (CAPTCHA_ENABLED) {
      return string().required(' ')
    }

    return string().nullable()
  }),
})
